<div class="d-flex flex-nowrap align-items-stretch form-control__wrapper"
     [class.ds-focus]="hasFocus"
     [class.ds-filled]="innerValue"
>
  <div class="form-control ds-resizable"
       [class.ds-focus]="hasFocus"
       [class.ds-filled]="innerValue"
       [class.ds-disabled]="isDisabled"
       [class.ds-invalid]="showError">
  <textarea
    class="form-control--input p-0"
    [(ngModel)]="innerValue"
    (input)="onChange()"
    (focus)="hasFocus = true;"
    (blur)="hasFocus = false;onBlur()"
    [attr.aria-label]="label"
    [disabled]="isDisabled"
  ></textarea>
    <ds-input-label *ngIf="label && !isDisabled" [for]="fieldName" [label]="label"></ds-input-label>
    <ds-input-placeholder [placeholder]="placeholder"></ds-input-placeholder>
  </div>
</div>
<ds-input-error [error]="error" [showError]="showError"></ds-input-error>
